// Mirrors BE MarketplaceDeveloper.WebAPI.Constant.AuditConstants.AuditEntityType
// (BE/MarketplaceDeveloper.WebAPI/Constant/AuditConstants.cs). Kept as a plain FE constant
// since no API surfaces the enum — add one row per feature that audits.
export const AUDIT_ENTITY_TYPES = [
  'WebhookRegistration',
  'Pipeline',
  'PipelineRun',
  'App',
  'IdpClient',
  'AppInstance',
  'AppPermission',
  'DockerImage',
  'AlertRule',
  'AppRating',
];

// Reserved system-actor user id (AuditSystemActor.UserId,
// BE/MarketplaceDeveloper.Infrastructures/Auditing/IAuditSink.cs). A record whose
// ActorUserId matches this value (or is null — the pre-hardening legacy shape, Wave 1
// AC-11 read-compat caveat) is not a human actor.
export const SYSTEM_ACTOR_USER_ID = '00000000-0000-0000-0000-0000000005ec';
